import { render, staticRenderFns } from "./aboutGsc.vue?vue&type=template&id=56c250ba&scoped=true"
import script from "./aboutGsc.vue?vue&type=script&lang=js"
export * from "./aboutGsc.vue?vue&type=script&lang=js"
import style0 from "./aboutGsc.vue?vue&type=style&index=0&id=56c250ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c250ba",
  null
  
)

export default component.exports